import { jsx } from "react/jsx-runtime";
import { c as classNames } from "../../../../index-e71f83b5.js";
import { useRef } from "react";
import FlashToast from "../../../atoms/info/FlashToast/FlashToast.js";
import { COMMON_CLASSNAME } from "../../../constants.js";
import { useToasts } from "../../../../hooks/useToasts/useToasts.js";
import { useWindowSize } from "../../../../hooks/useWindowSize/useWindowSize.js";
import "../../../../_commonjsHelpers-0c53d963.js";
import "../../../../utils-65a8d69b.js";
import "../../../../Fade-5a502c0e.js";
import "../../../../Transition-a28a969d.js";
import "react-dom";
import "../../../../styles/assets/images/icons/material/designSystem/Add.js";
import "../../../../styles/assets/images/icons/material/designSystem/AddCircle.js";
import "../../../../styles/assets/images/icons/material/designSystem/AddCircleFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/AdminPanelSettings.js";
import "../../../../styles/assets/images/icons/material/designSystem/AdminPanelSettingsFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Analytics.js";
import "../../../../styles/assets/images/icons/material/designSystem/AnalyticsFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Apartment.js";
import "../../../../styles/assets/images/icons/material/designSystem/Apps.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowBack.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowDropDown.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowDropUp.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowForward.js";
import "../../../../styles/assets/images/icons/material/designSystem/Bolt.js";
import "../../../../styles/assets/images/icons/material/designSystem/BoltFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/BugReport.js";
import "../../../../styles/assets/images/icons/material/designSystem/CalendarTodayFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Cancel.js";
import "../../../../styles/assets/images/icons/material/designSystem/CancelFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/CheckCircle.js";
import "../../../../styles/assets/images/icons/material/designSystem/CheckCircleFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ChevronLeft.js";
import "../../../../styles/assets/images/icons/material/designSystem/ChevronRight.js";
import "../../../../styles/assets/images/icons/material/designSystem/Circle.js";
import "../../../../styles/assets/images/icons/material/designSystem/CircleFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Close.js";
import "../../../../styles/assets/images/icons/material/designSystem/ConfirmationNumber.js";
import "../../../../styles/assets/images/icons/material/designSystem/ConfirmationNumberFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ContactSupport.js";
import "../../../../styles/assets/images/icons/material/designSystem/ContactSupportFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/CreditCard.js";
import "../../../../styles/assets/images/icons/material/designSystem/CreditCardFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Dashboard.js";
import "../../../../styles/assets/images/icons/material/designSystem/DashboardFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Delete.js";
import "../../../../styles/assets/images/icons/material/designSystem/DeleteFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/DirectionsCar.js";
import "../../../../styles/assets/images/icons/material/designSystem/DirectionsCarFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/DirectionsFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Edit.js";
import "../../../../styles/assets/images/icons/material/designSystem/EditFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ElectricCar.js";
import "../../../../styles/assets/images/icons/material/designSystem/ElectricCarFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Error.js";
import "../../../../styles/assets/images/icons/material/designSystem/ErrorFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/EventFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ExpandContent.js";
import "../../../../styles/assets/images/icons/material/designSystem/ExpandLess.js";
import "../../../../styles/assets/images/icons/material/designSystem/ExpandMore.js";
import "../../../../styles/assets/images/icons/material/designSystem/Favorite.js";
import "../../../../styles/assets/images/icons/material/designSystem/FavoriteFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/FirstPage.js";
import "../../../../styles/assets/images/icons/material/designSystem/Forward.js";
import "../../../../styles/assets/images/icons/material/designSystem/GarageHome.js";
import "../../../../styles/assets/images/icons/material/designSystem/GarageHomeFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Group.js";
import "../../../../styles/assets/images/icons/material/designSystem/GroupFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Home.js";
import "../../../../styles/assets/images/icons/material/designSystem/HomeFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Info.js";
import "../../../../styles/assets/images/icons/material/designSystem/InfoFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowLeft.js";
import "../../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowRight.js";
import "../../../../styles/assets/images/icons/material/designSystem/LastPage.js";
import "../../../../styles/assets/images/icons/material/designSystem/ListAlt.js";
import "../../../../styles/assets/images/icons/material/designSystem/ListAltFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Logout.js";
import "../../../../styles/assets/images/icons/material/designSystem/Mail.js";
import "../../../../styles/assets/images/icons/material/designSystem/MailFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Menu.js";
import "../../../../styles/assets/images/icons/material/designSystem/MonitorHeart.js";
import "../../../../styles/assets/images/icons/material/designSystem/MonitorHeartFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/MoreVert.js";
import "../../../../styles/assets/images/icons/material/designSystem/Notifications.js";
import "../../../../styles/assets/images/icons/material/designSystem/NotificationsFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Pending.js";
import "../../../../styles/assets/images/icons/material/designSystem/Person.js";
import "../../../../styles/assets/images/icons/material/designSystem/PersonFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/PriceChange.js";
import "../../../../styles/assets/images/icons/material/designSystem/PriceChangeFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/PushPin.js";
import "../../../../styles/assets/images/icons/material/designSystem/PushPinFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Refresh.js";
import "../../../../styles/assets/images/icons/material/designSystem/Reply.js";
import "../../../../styles/assets/images/icons/material/designSystem/Route.js";
import "../../../../styles/assets/images/icons/material/designSystem/Schedule.js";
import "../../../../styles/assets/images/icons/material/designSystem/Search.js";
import "../../../../styles/assets/images/icons/material/designSystem/Settings.js";
import "../../../../styles/assets/images/icons/material/designSystem/SettingsFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Shield.js";
import "../../../../styles/assets/images/icons/material/designSystem/ShieldFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Smartphone.js";
import "../../../../styles/assets/images/icons/material/designSystem/SmartphoneFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Tune.js";
import "../../../../styles/assets/images/icons/material/designSystem/VisibilityFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/VisibilityOffFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Warning.js";
import "../../../../styles/assets/images/icons/material/designSystem/WarningFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Work.js";
import "../../../../styles/assets/images/icons/material/designSystem/WorkFilled.js";
import "../../../../styles/assets/images/icons/brands/GoogleG.js";
import "../../../../sass/sass.js";
import "../../../atoms/buttons/FlashButton/FlashButton.js";
import "../../../atoms/info/FlashBadge/FlashBadge.js";
import "../../../atoms/info/FlashSpinner/FlashSpinner.js";
import "../../../atoms/buttons/FlashButtonGeneric.js";
import "../../../../index-5e4e4f4b.js";
import "../../../../axios-5f69b112.js";
import "../../../../Button-dadda608.js";
import "../../../../hooks/useInsights/useInsights.js";
import "../../../../utils/noOp.js";
import "../../../../hooks/useLogger/constants.js";
import "../../../../hooks/useLogger/useLogger.js";
import "../../../../hooks/useLogger/LoggerContext.js";
import "../../../../hooks/useLogger/types.js";
import "../../../../hooks/useInsights/InsightsContext.js";
import "../../../../hooks/useInsights/useInsightsImpression.js";
import "../../../../index-2d889c01.js";
import "../../../../hooks/useInsights/utils.js";
import "../../../../utils/invokeFn.js";
import "../../../atoms/buttons/FlashButton/constants.js";
import "../../../atoms/info/constants.js";
import "../../../atoms/info/utils.js";
import "../../../../hooks/useToasts/ToastContext.js";
import "../../../../hooks/useToasts/utils.js";
import "../../../../hooks/useWindowSize/WindowSizeContext.js";
import "../../../../isObject-ec23ace2.js";
import "../../../../isSymbol-c6f5cd95.js";
function FlashToasts() {
  const { toasts } = useToasts(), { windowIsMobile } = useWindowSize();
  return /* @__PURE__ */ jsx("div", { className: `${COMMON_CLASSNAME} flash-toasts`, children: /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames("position-fixed start-0 bottom-0 pb-flash-100", {
        "ps-flash-200": !windowIsMobile,
        "px-flash-200": windowIsMobile,
        "w-100": windowIsMobile
      }),
      children: /* @__PURE__ */ jsx("div", { className: "d-flex flex-column", children: toasts.reverse().map((toast, index) => /* @__PURE__ */ jsx(WrappedToast, { toast, index }, toast.props.toastId)) })
    }
  ) });
}
function WrappedToast(props) {
  var _a;
  const { toast } = props, { windowIsMobile } = useWindowSize(), { expireToast } = useToasts(), wrapperRef = useRef(null);
  function onClose(toastId) {
    if (toast.props.onClose) {
      toast.props.onClose(toastId);
      return;
    }
    expireToast(toastId);
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: "flash-toast-wrapper",
      ref: wrapperRef,
      style: { height: toast.props.isExpired ? 0 : (_a = wrapperRef.current) == null ? void 0 : _a.getBoundingClientRect().height },
      children: /* @__PURE__ */ jsx("div", { className: "pb-flash-100", children: /* @__PURE__ */ jsx(
        FlashToast,
        {
          ...toast.props,
          onClose,
          className: classNames({ "w-100": windowIsMobile }, toast.props.className)
        }
      ) })
    }
  );
}
export {
  FlashToasts as default
};
//# sourceMappingURL=FlashToasts.js.map
